var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4213 12.6563C17.1883 11.8903 14.7628 11.8958 12.5333 12.672C12.3712 12.7299 12.227 12.8289 12.1149 12.9594C12.0027 13.0899 11.9265 13.2474 11.8937 13.4163L11.1564 17.1048C11.1238 17.2679 11.051 17.4203 10.9446 17.5482C10.8383 17.6761 10.7017 17.7755 10.5472 17.8372L4.63312 20.2029C4.43275 20.2838 4.21152 20.2973 4.00276 20.2416C3.794 20.1858 3.60902 20.0637 3.47569 19.8936C2.58264 18.7389 2.14112 17.2982 2.23379 15.8414C2.32646 14.3846 2.94698 13.0115 3.97914 11.9792C7.16726 8.79106 11.4913 7 16 7C20.5086 7 24.8326 8.79106 28.0208 11.9792C29.0529 13.0115 29.6734 14.3846 29.7661 15.8414C29.8588 17.2982 29.4173 18.7389 28.5242 19.8936C28.3909 20.0637 28.2059 20.1858 27.9972 20.2416C27.7884 20.2973 27.5672 20.2838 27.3668 20.2029L21.4476 17.8352C21.2945 17.7739 21.1589 17.6758 21.0529 17.5495C20.9469 17.4231 20.8738 17.2726 20.8401 17.1111L20.0637 13.3939C20.0296 13.2259 19.9525 13.0696 19.8399 12.9403C19.7273 12.8111 19.5831 12.7132 19.4213 12.6563Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25H27",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneDisconnect);
export default __webpack_public_path__ + "static/media/PhoneDisconnect.edd225726995c59e33c6b53b38e7195d.svg";
export { ForwardRef as ReactComponent };